var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    id: "Pinia--Streamline-Svg-Logos",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n        Pinia Streamline Icon: https://streamlinehq.com\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M42.893 47.2045c6.2868-5.9898 4.3684-13.398-1.3254-22.3749-5.6938-8.977-17.1555-12.1707-19.2937-10.1334-2.1383 2.0372-2.6122 16.6027 3.0816 25.5796 5.6938 8.9769 11.2507 12.9185 17.5375 6.9287Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M48.3285 48.0338c4.6509 7.3328 10.8689 4.6516 18.5652-2.6812 7.6964-7.3329 10.8877-21.3793 9.3059-23.8733-1.5819-2.4941-13.6032-2.369-21.2996 4.9638-7.6964 7.3328-11.2225 14.2578-6.5715 21.5907Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M45.786 43.9994c7.7228.9482 10.7599-6.1864 12.1759-17.7192C59.378 14.7475 53.5406 2.55814 50.914 2.23563 48.2873 1.91312 39.4628 12.3022 38.0468 23.835c-1.416 11.5327.0165 19.2161 7.7392 20.1644Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M43.841 94.9997c16.1917 0 29.3229-4.7036 29.3229-26.0345S60.0327 30.1304 43.841 30.1304c-16.1918 0-29.3127 17.5039-29.3127 38.8348S27.6492 94.9997 43.841 94.9997Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaadcc",
    d: "M58.6511 64.6109c2.3132 0 4.1883-.8722 4.1883-1.948 0-1.0759-1.8751-1.9481-4.1883-1.9481-2.3131 0-4.1882.8722-4.1882 1.9481 0 1.0758 1.8751 1.948 4.1882 1.948Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaadcc",
    d: "M27.6344 63.4272c2.2958.2819 4.2633-.3552 4.3944-1.423.1311-1.0679-1.6237-2.1621-3.9196-2.444-2.2959-.2819-4.2633.3553-4.3945 1.4231-.1311 1.0679 1.6238 2.162 3.9197 2.4439Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M38.9693 60.8439c-.1804-.2677-.5436-.3384-.8113-.1581-.2676.1804-.3384.5436-.158.8113.8968 1.3306 2.276 2.103 4.0904 2.3103 1.8065.2064 3.4194-.2565 4.8028-1.3808.2504-.2035.2885-.5716.0849-.8221-.2036-.2504-.5716-.2885-.8221-.0849-1.1378.9247-2.4367 1.2975-3.9329 1.1265-1.4884-.1701-2.5572-.7686-3.2538-1.8022Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M30.3033 51.8356c1.156-.0403 2.2188.3916 3.0027 1.1226.784.7309 1.2891 1.761 1.3294 2.9169.0404 1.1559-.3916 2.2187-1.1226 3.0026-.731.7839-1.7612 1.289-2.9171 1.3293-1.1559.0404-2.2186-.3915-3.0025-1.1226-.7838-.731-1.2888-1.761-1.3292-2.917-.0404-1.1559.3916-2.2186 1.1225-3.0025.731-.7839 1.761-1.2889 2.9168-1.3293Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30.5242 55.3364c-.0263-.7525-.658-1.3415-1.4103-1.3152-.7527.0263-1.3416.6578-1.3153 1.4104.0263.7526.6577 1.3415 1.4105 1.3152.7522-.0265 1.3413-.6578 1.3151-1.4104Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M55.6815 52.8981c1.1559-.0403 2.2187.3916 3.0026 1.1225.7839.731 1.2889 1.7611 1.3293 2.917.0403 1.1559-.3916 2.2187-1.1226 3.0026-.731.784-1.761 1.289-2.917 1.3293-1.1558.0404-2.2187-.3916-3.0026-1.1226-.7839-.731-1.2889-1.7611-1.3293-2.917-.0403-1.1559.3916-2.2186 1.1226-3.0025.7311-.7839 1.7611-1.2889 2.917-1.3293Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30.2747 50.9597c2.7957-.0976 5.1411 2.0893 5.2387 4.8849.0977 2.7957-2.0894 5.141-4.8852 5.2387-2.7956.0976-5.1407-2.0894-5.2383-4.8852-.0977-2.7956 2.0893-5.1408 4.8848-5.2384Zm3.4866 4.9461c-.0639-1.8279-1.5974-3.2578-3.4254-3.194-1.8279.0639-3.2577 1.5972-3.1939 3.4251.0639 1.8281 1.5972 3.258 3.425 3.1942 1.8281-.0638 3.2581-1.5973 3.1943-3.4253Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M55.6499 52.0222c2.7957-.0976 5.1409 2.0893 5.2385 4.8849.0977 2.7958-2.0893 5.141-4.885 5.2387-2.7956.0976-5.1409-2.0895-5.2385-4.8852-.0977-2.7955 2.0894-5.1408 4.885-5.2384Zm3.4864 4.9461c-.0639-1.8279-1.5972-3.2578-3.4252-3.194-1.8279.0639-3.2579 1.5973-3.1941 3.4251.0639 1.8281 1.5973 3.258 3.4252 3.1942 1.8281-.0638 3.2579-1.5972 3.1941-3.4253Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M55.9011 56.3994c-.0263-.7526-.6578-1.3415-1.4104-1.3152-.7525.0263-1.3414.6578-1.3152 1.4104.0263.7525.6579 1.3415 1.4104 1.3152.7526-.0263 1.3415-.6578 1.3152-1.4104Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecb732",
    d: "m22.4113 70.2001 6.3547 6.6122 4.5595-4.8504c.4053-.4311 1.0833-.4521 1.5145-.0468.4311.4052.4521 1.0833.0468 1.5145l-4.634 4.9298 6.5739 6.8405c.41.4267.3965 1.1049-.0301 1.5149-.4266.41-1.1049.3966-1.5149-.0301l-6.4985-6.762-3.0521 3.247c-.4053.4311-1.0833.4521-1.5145.0468-.4311-.4053-.4521-1.0833-.0468-1.5145l3.1267-3.3262-6.4302-6.6909c-.41-.4266-.3965-1.1049.0301-1.5149.4266-.41 1.1049-.3965 1.5149.0301Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecb732",
    d: "M65.0854 70.2001c.41-.4266 1.0883-.4401 1.5149-.0301.4267.41.4401 1.0883.0301 1.5149l-6.4303 6.6909 3.1268 3.3262c.394.4192.3852 1.0718-.0118 1.4801l-.035.0344c-.4312.4053-1.1092.3843-1.5145-.0468l-3.0523-3.247-6.4983 6.762c-.3986.4148-1.0508.4391-1.4788.0633l-.0361-.0332c-.4266-.41-.4401-1.0882-.0301-1.5149l6.5737-6.8405-4.6338-4.9298c-.394-.4192-.3852-1.0718.0118-1.4801l.035-.0344c.4312-.4053 1.1092-.3843 1.5145.0468l4.5593 4.8504 6.3549-6.6122Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc73b",
    d: "M50.4483 37.0677c.4185.4184.4185 1.0968 0 1.5152l-4.9889 4.9891 3.0409 3.041c.4068.4068.4181 1.0594.0339 1.4798l-.0339.0355c-.4184.4184-1.0968.4184-1.5152 0l-3.041-3.0409-3.0411 3.0409c-.4184.4184-1.0968.4184-1.5152 0-.4184-.4185-.4184-1.0968 0-1.5153l3.0409-3.041-4.9889-4.9891c-.4068-.4068-.4181-1.0593-.0339-1.4797l.0339-.0355c.4184-.4184 1.0968-.4184 1.5152 0l4.9891 4.9889 4.989-4.9889c.4185-.4184 1.0968-.4184 1.5152 0Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 999.028,
    x2: 1322.02,
    y1: -748.436,
    y2: 819.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ce63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51a256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 842.523,
    x2: -725.153,
    y1: 1002.32,
    y2: 1324.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ce63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51a256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1036.61,
    x2: 735.026,
    y1: 123.263,
    y2: 2579.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae99c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52ce63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 3027.09,
    x2: 2540.32,
    y1: 1163.56,
    y2: 6509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe56c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc63a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinia);
export default __webpack_public_path__ + "static/media/pinia.57bc101edbce0218cd7cffe5970cf06c.svg";
export { ForwardRef as ReactComponent };